// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countdown {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  font-size: 1.6rem;
  display: inline-block;
  transition: background-color 0.3s ease;
  
  /* Ajouts pour stabiliser la largeur */
  font-family: monospace;
  min-width: 100px; /* Ajustez cette valeur selon vos besoins */
  text-align: center;
  white-space: nowrap;
}

.countdown.urgent {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
  border: 2px solid #dc2626;
}

.countdown.warning {
  background: rgba(217, 119, 6, 0.1);
  color: #d97706;
  border: 2px solid #d97706;
}

.countdown.normal {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
  border: 2px solid #16a34a;
}
`, "",{"version":3,"sources":["webpack://./src/composants/CompteARebourd/CompteARebourd.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;;EAEtC,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB,EAAE,2CAA2C;EAC7D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".countdown {\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n  font-size: 1.6rem;\r\n  display: inline-block;\r\n  transition: background-color 0.3s ease;\r\n  \r\n  /* Ajouts pour stabiliser la largeur */\r\n  font-family: monospace;\r\n  min-width: 100px; /* Ajustez cette valeur selon vos besoins */\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.countdown.urgent {\r\n  background: rgba(220, 38, 38, 0.1);\r\n  color: #dc2626;\r\n  border: 2px solid #dc2626;\r\n}\r\n\r\n.countdown.warning {\r\n  background: rgba(217, 119, 6, 0.1);\r\n  color: #d97706;\r\n  border: 2px solid #d97706;\r\n}\r\n\r\n.countdown.normal {\r\n  background: rgba(22, 163, 74, 0.1);\r\n  color: #16a34a;\r\n  border: 2px solid #16a34a;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
